module.exports = __webpack_public_path__ + "static/media/md-anonymous.7ab88ede.svg";